import { type RouteHookProps, useRoute } from '@dolcevia/lib/hooks/useRoute';
import { coordinatesParser } from '@dolcevia/lib/searchParams';
import type {
  DragEndEvent,
  LatLngExpression,
  LatLngLiteral,
  Map as MapType,
} from 'leaflet';
import DraggableLines from 'leaflet-draggable-lines';
import { HighlightablePolyline } from 'leaflet-highlightable-layers';
import { useQueryState } from 'nuqs';
import { iconDolcevia } from './assets/marker';
import { findInsertionIndex } from './utils';
interface DraggableLinesEvent extends DragEndEvent {
  to: LatLngLiteral | null;
  from: LatLngLiteral | null;
}
const getMarker = (draggable: boolean) => () => {
  return {
    icon: iconDolcevia,
    draggable,
  };
};

export const useDraggableMarker = (
  map: MapType | null,
  routeOverride?: RouteHookProps,
) => {
  const { data: geoJson } = useRoute({ ...routeOverride });
  const [coordinates, setCoordinates] = useQueryState(
    'coordinates',
    coordinatesParser,
  );
  const params = {
    coordinates: routeOverride?.coordinatesOverride ?? coordinates,
  };
  const isDraggable = !routeOverride?.coordinatesOverride;
  const routeLayer = new HighlightablePolyline([], {
    color: '#FFDE69',
    outlineColor: '#082946',
    outlineWeight: 3,
    weight: 3,
    draggableLinesRoutePoints: params.coordinates.map((p) => [
      p.lng,
      p.lat,
    ]) as LatLngExpression[],
  });

  if (map && geoJson) {
    const draggable = new DraggableLines(map, {
      tempMarkerOptions: getMarker(isDraggable),
      dragMarkerOptions: getMarker(isDraggable),
      plusMarkerOptions: getMarker(isDraggable),
      plusTempMarkerOptions: getMarker(isDraggable),
    });
    if (isDraggable) {
      draggable.enable();
    }
    routeLayer.addTo(map);
    routeLayer.setLatLngs(
      geoJson
        ? geoJson.features[0].geometry.coordinates.map((p) => [p[1], p[0]])
        : [],
    );
    // @ts-ignore
    draggable.on('dragend', (e: DraggableLinesEvent) => {
      if (!e.to || !e.from) return;
      const index = findInsertionIndex(
        coordinates
          .map((p) => {
            if (!p.lat || !p.lng) return undefined;
            return [p.lng, p.lat];
          })
          .filter((el) => el !== undefined) as [number, number][],
        [e.from.lng, e.from.lat],
      );
      const newCoordinates = coordinates.toSpliced(index, 0, {
        //@ts-ignore
        lat: e.to.lat,
        //@ts-ignore
        lng: e.to.lng,
        title: 'Custom point',
      });
      setCoordinates(newCoordinates);
      routeLayer.setLatLngs(
        geoJson
          ? geoJson.features[0].geometry.coordinates.map((p) => [p[1], p[0]])
          : [],
      );
    });
  }
};
